module.exports = __webpack_public_path__ + "static/media/M22ws.1a1bfdd2.pdf";